var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeccoCrOlogoInnershadow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 419,
    height: 284,
    viewBox: "0 0 419 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_391_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.617 227.971C261.632 227.971 250.027 239.757 250.027 255.996C250.027 272.203 261.632 283.971 277.617 283.971C289.928 283.971 299.723 276.523 303.027 264.838H296.456C293.483 272.978 286.51 277.801 277.617 277.801C265.448 277.801 256.615 268.632 256.615 255.996C256.615 243.334 265.448 234.145 277.617 234.145C286.226 234.145 293.112 238.663 296.223 246.291H302.779C299.439 235.101 289.745 227.971 277.617 227.971Z",
    fill: "#80BA4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.533 234.853H335.252C342.091 234.853 346.865 239.211 346.865 245.452C346.865 251.689 342.091 256.048 335.252 256.048H321.533V234.853ZM346.855 282.971H354.032L341.267 261.301L342.864 260.71C349.444 258.268 353.528 252.456 353.528 245.531C353.528 235.933 346.068 228.971 335.799 228.971H315.032V282.971H321.533V261.934H334.599L346.855 282.971Z",
    fill: "#80BA4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.552 255.971C368.552 243.492 377.793 234.088 390.059 234.088C402.293 234.088 411.521 243.492 411.521 255.971C411.521 268.45 402.293 277.858 390.059 277.858C377.793 277.858 368.552 268.45 368.552 255.971ZM418.036 255.976C418.036 240.01 406.006 227.973 390.059 227.973C374.08 227.973 362.036 240.01 362.036 255.971C362.036 271.931 374.08 283.973 390.059 283.973C406.006 283.973 418.036 271.936 418.036 255.976Z",
    fill: "#80BA4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.52 274.617C213.725 274.617 207.377 268.273 207.377 260.472C207.377 252.676 213.725 246.331 221.52 246.331C229.32 246.331 235.664 252.676 235.664 260.472C235.664 268.273 229.32 274.617 221.52 274.617ZM221.52 237.974C209.095 237.974 199.02 248.045 199.02 260.472C199.02 272.899 209.095 282.974 221.52 282.974C233.946 282.974 244.02 272.899 244.02 260.472C244.02 248.045 233.946 237.974 221.52 237.974Z",
    fill: "#007049"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.708 246.328C128.108 246.328 133.537 250.529 135.339 256.294H144.01C142.031 245.863 132.803 237.972 121.708 237.972C109.173 237.972 99.01 248.047 99.01 260.472C99.01 272.898 109.173 282.972 121.708 282.972C132.803 282.972 142.031 275.077 144.01 264.65H135.339C133.537 270.415 128.108 274.612 121.708 274.612C113.84 274.612 107.444 268.268 107.444 260.472C107.444 252.672 113.84 246.328 121.708 246.328Z",
    fill: "#007049"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.714 246.328C178.114 246.328 183.542 250.529 185.344 256.294H194.015C192.036 245.863 182.808 237.972 171.714 237.972C159.178 237.972 149.015 248.047 149.015 260.472C149.015 272.898 159.178 282.972 171.714 282.972C182.808 282.972 192.036 275.077 194.015 264.65H185.344C183.542 270.415 178.114 274.612 171.714 274.612C163.845 274.612 157.45 268.268 157.45 260.472C157.45 252.672 163.845 246.328 171.714 246.328Z",
    fill: "#007049"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1075 273.603H8.53033V259.154H26.1075C30.1742 259.154 33.47 262.392 33.47 266.381C33.47 270.37 30.1742 273.603 26.1075 273.603ZM26.1075 250.791H8.53033V236.343H26.1075C30.1742 236.343 33.47 239.576 33.47 243.564C33.47 245.041 33.0175 246.408 32.2419 247.549C35.0114 248.419 37.5087 249.877 39.6182 251.747C41.1182 249.365 42 246.571 42 243.564C42 234.957 34.8824 227.975 26.1075 227.975H0V281.975H26.1075C34.8824 281.975 42 274.993 42 266.381C42 257.769 34.8824 250.791 26.1075 250.791Z",
    fill: "#007049"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5047 246.328C77.8486 246.328 83.2294 250.529 85.0153 256.294H57.9938C59.78 250.529 65.1608 246.328 71.5047 246.328ZM71.5047 237.972C59.079 237.972 49.0049 248.047 49.0049 260.472C49.0049 272.898 59.079 282.972 71.5047 282.972C80.1589 282.972 87.6649 278.08 91.4272 270.917H81.0138C78.5041 273.21 75.1673 274.612 71.5047 274.612C65.1608 274.612 59.78 270.415 57.9938 264.65H85.0153H89.8264H93.6111C93.8643 263.294 94.0045 261.901 94.0045 260.472C94.0045 248.047 83.9301 237.972 71.5047 237.972Z",
    fill: "#007049"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.016 16.9998C211.427 16.9998 215.018 13.185 215.018 8.50003C215.018 3.81503 211.427 -7.24792e-05 207.016 -7.24792e-05C202.606 -7.24792e-05 199.019 3.81503 199.019 8.50003C199.019 13.185 202.606 16.9998 207.016 16.9998Z",
    fill: "#80BA4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.016 202.98C211.427 202.98 215.018 199.165 215.018 194.48C215.018 189.795 211.427 185.98 207.016 185.98C202.606 185.98 199.019 189.795 199.019 194.48C199.019 199.165 202.606 202.98 207.016 202.98Z",
    fill: "#007049"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.402 112.067L200.817 70.9872H180.019L246.506 122.315C251.238 125.943 254.067 131.664 254.067 137.618C254.067 149.44 244.422 159.059 232.565 159.059H164.979V106.213L152.023 96.2769V171.987H232.565C251.565 171.987 267.023 156.569 267.023 137.618C267.023 127.673 262.304 118.122 254.402 112.067Z",
    fill: "#007049"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.972 43.9616H237.001C246.407 43.9616 254.055 51.6251 254.055 61.0383C254.055 70.4566 246.407 78.1154 237.001 78.1154H228.438L244.098 90.1955C257.224 86.9902 267.016 75.1542 267.016 61.0383C267.016 44.4682 253.549 30.9881 237.001 30.9881H152.016V81.5601L220.145 133.989H241.274L164.972 75.168V43.9616Z",
    fill: "#80BA4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_391_3",
    x: 0,
    y: 0,
    width: 418.036,
    height: 287.973,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_391_3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeccoCrOlogoInnershadow);
export default __webpack_public_path__ + "static/media/BeccoCRO logo_innershadow.3512019b5b8704a7975ac7b2d334ff68.svg";
export { ForwardRef as ReactComponent };